import { render, staticRenderFns } from "./MAS.vue?vue&type=template&id=33189bb3&"
import script from "./MAS.vue?vue&type=script&lang=ts&"
export * from "./MAS.vue?vue&type=script&lang=ts&"
import style0 from "./MAS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports